import React, { useState, useEffect, createContext, useContext, useCallback } from "react";
import "./LoginPage.css";
import Maindashboard from "../../MainDashBoard_Page/Main_Dashboard";
import configData from "../../../config.json";
import LoadingComponent from "../../loading_component";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ColorContext } from "../../../ColorContext";
import ParticleBackground from "../../common/ParticleBackground";

export const EmplContext = createContext();

const LoginPage = () => {
  const [resultData, setResultData] = useState({});
  const [authenticated, setAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [isemphr, setIsemphr] = useState(false);
  const [isempwfh, setIsempwfh] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const { setBgColor, setTextColor, pageColor, setPageColor } = useContext(ColorContext);
  const [isempmanager, setIsempmanager] = useState(false);

  const fetchData = useCallback(async (storedUsername, storedPin) => {
    if (storedUsername) {
      try {
        setLoading(true);
        const url = `${configData.SERVER_URL}/login`;
        const secretKey = configData.SECRET_Key;
        const body = JSON.stringify({
          username: storedUsername,
          pin: storedPin,
          secretKey,
        });
        const headers = { "Content-Type": "application/json" };
        const response = await fetch(url, { method: "POST", headers, body });
        const data = await response.json();
        const resultData = JSON.parse(data.result);
        if (resultData.success === true) {
          setResultData(resultData);
          setBgColor(resultData.theme_color.split(",")[0]);
          setTextColor(resultData.theme_color.split(",")[1]);
          setPageColor(resultData.theme_color.split(",")[2]);
          handleLoggin(resultData.name);
          setIsemphr(resultData.Isemphr);
          setIsempwfh(resultData.Isempwfh);
          setIsempmanager(resultData.Isempmanager);
        } else if (resultData.success === false && resultData.message === "Wrongpassword") {
          Swal.fire({ icon: "error", title: "Error", text: "Please enter correct pin." });
          localStorage.clear();
        } else if (resultData.success === false && resultData.message === "AccessDenied") {
          Swal.fire({ icon: "error", title: "Error", text: "Please enter correct credentials" });
          localStorage.clear();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        localStorage.clear();
      } finally {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPin = localStorage.getItem("pin");
    fetchData(storedUsername, storedPin);
    const storedAuth = localStorage.getItem("authenticated");
    if (storedAuth) setAuthenticated(JSON.parse(storedAuth));
  }, [fetchData]);

  const handleLoggin = () => {
    setAuthenticated(true);
    localStorage.setItem("authenticated", JSON.stringify(true));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    localStorage.setItem("username", username);
    localStorage.setItem("pin", pin);
    fetchData(username, pin);
  };

  if (loading) return <LoadingComponent />;

  if (authenticated) {
    return (
      <EmplContext.Provider value={{ resultData, setAuthenticated, isemphr, isempwfh, fetchData, isempmanager }}>
        <Maindashboard />
      </EmplContext.Provider>
    );
  }

  return (
    <div className="login-page" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/background.jpg)` }}>
      <ParticleBackground />
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <img src="company_logo.png" alt="Company Logo" />
        </div>

        {/* Title */}
        <div className="login-header">
          <h1>Welcome Back</h1>
          <p>Sign in to your account</p>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin}>
          <div className="login-field">
            <label>Email</label>
            <input
              autoFocus
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </div>

          <div className="login-field">
            <label>Pin</label>
            <div className="login-pin-wrapper">
              <input
                type={showPin ? "text" : "password"}
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                placeholder="Enter your pin"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="login-eye-btn"
                onClick={() => setShowPin(!showPin)}
                tabIndex={-1}
              >
                {showPin ? <VisibilityOff sx={{ fontSize: 20 }} /> : <Visibility sx={{ fontSize: 20 }} />}
              </button>
            </div>
          </div>

          <div className="login-forgot">
            <Link to="/forget_password">Forget Pin?</Link>
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>
        </form>
      </div>

      <p className="login-footer">&copy; {new Date().getFullYear()} O2B Technologies</p>
    </div>
  );
};

export default LoginPage;